import portrait from "../assets/images/portraits/IMG_0012(cut).jpg";
import sketch from "../assets/images/pinal2.jpg";
import { projects } from "./projects";

export const profile = {
  legalName: "Joseph Rey Amper Tolentino",
  displayName: "Joseph Rey Tolentino",
  /** The legal name as set on the dossier: given names, then family names. */
  nameLines: ["Joseph Rey", "Amper Tolentino"],
  shortName: "JRT",
  caseNumber: "CASE FILE #001",
  subjectId: "SUBJ-JRT-001",
  status: "ACTIVE",
  experienceYears: "6+",
  location: "Cavite, Philippines",
  email: "josephreytolentino@gmail.com",
  /** Primary identity. Everything else on the board is filed under this. */
  title: "Software Engineer",
  /** Secondary titles, shown as aliases. */
  aliases: ["Web / AI Developer", "Operations Manager"],
  headline: "Software Engineer",
  photo: portrait,
  photoLabel: "SUBJECT · CONFIRMED ID",
  sketch,
  sketchLabel: "COMPOSITE SKETCH",
  summary:
    "Software engineer who ships production web apps end to end — React, Vue, and Next.js up front; APIs, data, and integrations behind. Also builds the AI-assisted workflows and CRM automation that keep those products running.",
  brief:
    "Ships production web apps end-to-end: UI, APIs, integrations, and the ops layer around them. Employers get someone who can both build the product and make it run itself.",
  nowBuilding: "Product apps, health systems, and CRM pipelines — shipped, not staged.",
  socials: [
    { href: "https://github.com/abi-collab", label: "GitHub", id: "github" },
    { href: "https://www.linkedin.com/in/josephreytolentino/", label: "LinkedIn", id: "linkedin" },
    { href: "https://www.facebook.com/developerAbi", label: "Facebook", id: "facebook" },
    { href: "mailto:josephreytolentino@gmail.com", label: "Email", id: "email" },
  ],
  stats: [
    { value: "6+", label: "Years on record" },
    { value: "12+", label: "Products shipped" },
    { value: String(projects.length), label: "Exhibits on this board" },
  ],
};
